<template>
  <div class="header">
    <h2>
      冲石科技数据分析系统
    </h2>
    <!-- <el-popover placement="top-start" ttle="" width="" trigger="hover" content="">
      <el-button type="text" @click="updatePsd">修改密码</el-button>
      <el-button type="text" @click="outLogin">退出登录</el-button>
      <i class="el-icon-menu" slot="reference"></i>
    </el-popover> -->
    <!-- <span class="currentUser">当前用户：管理员</span> -->
    <el-dialog title="修改密码" :visible.sync="changePassword" width="30%" :show-close="false">
      <el-form :model="changePsd" :rules="psdRules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="原密码" prop="oldPsd">
          <el-input placeholder="请输入原密码" type="password" v-model="changePsd.oldPsd" class="psdInput" clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPsd">
          <el-input placeholder="请输入新密码" type="password" v-model="changePsd.newPsd" class="psdInput" clearable></el-input>
        </el-form-item>
        <el-form-item label="重复新密码" prop="repeat">
          <el-input placeholder="请再输入新密码" type="password" v-model="changePsd.repeat" class="psdInput" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import api from '@/api/home'
  export default {
    name: 'headerNav',
    data() {
      return {
        changePassword: false,
        changePsd: {},
        psdRules: {
          oldPsd: [{
              required: true,
              message: '请输入原密码',
              trigger: 'blur'
            },
            {
              min: 6,
              max: 15,
              message: '长度在 6 到 15 个字符',
              trigger: 'blur'
            }
          ],
          newPsd: [{
              required: true,
              message: '请输入新密码',
              trigger: 'blur'
            },
            {
              min: 6,
              max: 15,
              message: '长度在 6 到 15 个字符',
              trigger: 'blur'
            }
          ],
          repeat: [{
              required: true,
              message: '请再次输入新密码',
              trigger: 'blur'
            },
            {
              min: 6,
              max: 15,
              message: '长度在 6 到 15 个字符',
              trigger: 'blur'
            }
          ]
        },
      }
    },
    mounted() {

    },
    methods: {
      updatePsd() {
        this.changePassword = true;
      },
      cancel() {
        this.changePassword = false;
        this.changePsd = {};
        this.$refs['ruleForm'].resetFields();
      },
      sure() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            console.log('you success!!');
            this.changePsd = {};
            this.$refs['ruleForm'].resetFields();
            this.changePassword = false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      outLogin() {
        this.$router.push({
          name: 'login'
        })
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../css/common.css';

  .header {
    width: 100%;

    i {
      float: right;
      margin-top: 18px;
      font-size: 24px;
      color: #fff
    }

    h2 {
      float: left;
      font-size: 22px;
      font-weight: bold;
      color: #fff;
      margin-top: 15px;
      letter-spacing: 2px;
    }

    .currentUser {
      color: #fff;
      float: right;
      margin-right: 18px;
      margin-top: 18px;
      font-size: 16px;
    }

    .el-form-item {
      padding: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/common/nav/headerNav.vue